import PropTypes from 'prop-types';

import { useStyles } from './useStyles';

export const ResourceUrlNode = ({ attributes, children }) => {
  const styles = useStyles();

  return (
    <span
      className={styles.root}
      {...attributes}
    >
      {children}
    </span>
  );
};

ResourceUrlNode.propTypes = {
  attributes: PropTypes.shape({}).isRequired,
  children: PropTypes.node,
};
ResourceUrlNode.defaultProps = {
  children: null,
};
